import { Icon } from 'antd';
import styled from 'styled-components';
import React from 'react';
import { IconLinkContainer } from './style';

export const IconLink = styled.a`
    line-height: 32px;
    display: inline-block;
    margin-left: 26px;
    font-size: 14px;
`;

export default function YoutubeLink({ href, title }) {
    return <IconLinkContainer>
        <Icon type='youtube' style={{ color: 'black', fontSize: 18, left: 2, top: 8, position: 'absolute' }}/>
        <IconLink href={href} rel='noopener noreferrer' target='_blank'>
            {title ? title : href}
        </IconLink>
    </IconLinkContainer>
}

